import { useEffect, useState } from "react";

const LOADER_TEXTS = [
	"Checking the address...",
	"Analyzing the website...",
	"Getting relevant information...",
	"Fetching data...",
	"Drawing charts...",
	"Generating report...",
] as const;

function MainLoader() {
	const [step, setStep] = useState(0);

	useEffect(() => {
		const timer = setTimeout(() => {
			setStep((prev) => (prev + 1) % LOADER_TEXTS.length);
		}, 2500);

		return () => clearTimeout(timer);
	}, [step]);

	const progress = ((step + 1) / LOADER_TEXTS.length) * 100;

	return (
		<section className="page page--loader" aria-live="polite">
			<div className="panel loader-panel">
				<p className="eyebrow">Procesando auditoría</p>
				<h2>{LOADER_TEXTS[step]}</h2>
				<div className="progress-bar" aria-hidden>
					<span style={{ width: `${progress}%` }} />
				</div>
				<p className="loader-panel__hint">
					Esto puede tardar hasta 45 segundos dependiendo de la complejidad del sitio.
				</p>
			</div>
		</section>
	);
}

export default MainLoader;
